var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A5D11251-E492-49E2-8DE4-EFC6086C35FF@0.5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navic-GoSend---Phase-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.5-Details---On-hold",
    transform: "translate(-18.000000, -713.000000)",
    fill: "#00880D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card",
    transform: "translate(0.000000, 96.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Status",
    transform: "translate(0.000000, 399.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "List",
    transform: "translate(16.000000, 210.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "multimedia/24/ic_pause_filled_circle",
    transform: "translate(0.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5,2 C18.299,2 23,6.701 23,12.5 C23,18.299 18.299,23 12.5,23 C6.701,23 2,18.299 2,12.5 C2,6.701 6.701,2 12.5,2 Z M8.5,10 L8.5,15 C8.5,15.8284271 9.17157288,16.5 10,16.5 C10.8284271,16.5 11.5,15.8284271 11.5,15 L11.5,10 C11.5,9.17157288 10.8284271,8.5 10,8.5 C9.17157288,8.5 8.5,9.17157288 8.5,10 Z M13.5,10 L13.5,15 C13.5,15.8284271 14.1715729,16.5 15,16.5 C15.8284271,16.5 16.5,15.8284271 16.5,15 L16.5,10 C16.5,9.17157288 15.8284271,8.5 15,8.5 C14.1715729,8.5 13.5,9.17157288 13.5,10 Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.e0ff1f2dd0029c1571394f4aa0681c8b.svg";
export { ForwardRef as ReactComponent };